import React from "react";
import { Crown, Sparkles, Gem, Star, Flame, Trophy, Medal } from "lucide-react";

const TIER_STYLE = {
  "Newcomer":     { color: "#A0A0AB", icon: Star,      bg: "rgba(160,160,171,0.12)" },
  "Starter":      { color: "#00F0FF", icon: Star,      bg: "rgba(0,240,255,0.12)" },
  "Rising Fan":   { color: "#FFD600", icon: Flame,     bg: "rgba(255,214,0,0.15)" },
  "Pro":          { color: "#00FF66", icon: Sparkles,  bg: "rgba(0,255,102,0.15)" },
  "Vault Tier 1": { color: "#B026FF", icon: Trophy,    bg: "rgba(176,38,255,0.18)" },
  "Vault Tier 2": { color: "#FF3B7C", icon: Gem,       bg: "rgba(255,59,124,0.18)" },
  "Vault Tier 3": { color: "#FF0055", icon: Medal,     bg: "rgba(255,0,85,0.22)" },
  "Elite":        { color: "#00F0FF", icon: Crown,     bg: "linear-gradient(135deg,#00F0FF33,#B026FF33)" },
  "Legend":       { color: "#FFD600", icon: Crown,     bg: "linear-gradient(135deg,#FFD60033,#FF005533)" },
};

export default function TierBadge({ tier = "Newcomer", size = "md", className = "" }) {
  const s = TIER_STYLE[tier] || TIER_STYLE.Newcomer;
  const Icon = s.icon;
  const isCompact = size === "sm";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold tracking-widest uppercase ${isCompact ? "px-2 py-0.5 text-[9px]" : "px-3 py-1 text-[10px]"} ${className}`}
      style={{ background: s.bg, color: s.color, border: `1px solid ${s.color}55` }}
    >
      <Icon className={isCompact ? "w-2.5 h-2.5" : "w-3 h-3"} />
      {tier}
    </span>
  );
}
